import { useState } from "react";

const MenuHandler = ({ enhancedMenuArray, onFieldTypeSelect }) => {
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [activeSubMenuIndex, setActiveSubMenuIndex] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleMenuClick = (index, childIndex = null, e = null) => {
    if (e) e.stopPropagation();
    const menuItem = enhancedMenuArray[index];

    if (childIndex !== null && menuItem.child) {
      // Handle sub-menu item click - hide dropdown but keep active state
      const childItem = menuItem.child[childIndex];
      const selectedFieldType = {
        type: childItem.name,
        label: childItem.label,
        icon: childItem.icon,
        inputType: childItem.inputType,
        dimensions: childItem.dimensions,
      };

      onFieldTypeSelect(selectedFieldType);
      setActiveMenuIndex(index); // Keep parent menu active
      setActiveSubMenuIndex(childIndex); // Set active sub-menu item
      setDropdownVisible(false); // Hide dropdown after child selection
    } else if (!menuItem.child) {
      // Handle parent menu item without children (like "Text")
      const selectedFieldType = {
        type: menuItem.name,
        label: menuItem.label,
        icon: menuItem.icon,
        inputType: menuItem.inputType,
        dimensions: menuItem.dimensions,
      };

      onFieldTypeSelect(selectedFieldType);
      setActiveMenuIndex(index); // Set parent menu as active
      setActiveSubMenuIndex(null); // Clear sub-menu active state
      setDropdownVisible(false); // Hide dropdown for non-child items
    } else {
      // Handle parent menu item click with children (toggle dropdown)
      const isCurrentlyActive = activeMenuIndex === index;

      if (!isCurrentlyActive) {
        // Clicking a different parent menu - clear previous active states
        setActiveMenuIndex(index);
        setActiveSubMenuIndex(null); // Clear sub-menu active when switching parent
        setDropdownVisible(true); // Show dropdown
      } else {
        // Clicking the same parent menu - if dropdown is hidden, show it; otherwise toggle it
        if (!dropdownVisible) {
          setDropdownVisible(true); // Show dropdown if it's hidden
        } else {
          setActiveMenuIndex(null);
          setActiveSubMenuIndex(null);
          setDropdownVisible(false);
        }
      }
    }
  };

  const clearSelection = () => {
    setActiveMenuIndex(null);
    setActiveSubMenuIndex(null);
    setDropdownVisible(false);
  };

  return {
    activeMenuIndex,
    activeSubMenuIndex,
    dropdownVisible,
    handleMenuClick,
    clearSelection,
  };
};

export default MenuHandler;
